import React from "react";
import { LoginSocialApple } from "reactjs-social-login";
import { AppleLoginButton } from "react-social-login-buttons";

const client_id = process.env.REACT_APP_APPLE_ID || "";



const LoginWithApple = ({ formType, setFormType }) => {

  if (!client_id) { 
    console.error('Client ID is missing. Please provide a valid Google client ID.');
     return ( 
     <div style={{ color: 'red', textAlign: 'center', margin: '20px' }}> <p>Error: Client ID is missing. Please contact support.</p> </div>
    
    );
   }

  return (
    <LoginSocialApple
      client_id={client_id || ""}
      onResolve={({ provider, data }) => {
        console.log({ provider, data });
      }}
      onReject={(err) => {
        console.log(err);
      }}
    >
      <AppleLoginButton
        style={{ fontSize: "14px", height: "38px", padding: "0 22px" }}
        iconSize={"20px"}
      >
        <span>{formType === "login" ? "Log in" : "Sign up"} with Apple</span>
      </AppleLoginButton>
    </LoginSocialApple>
  );
};

export default LoginWithApple;
